import { Component } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-topup-point-log',
    templateUrl: './topup-point-log.component.html',
    styleUrls: ['./topup-point-log.component.scss']
})
export class TopupPointLogComponent {

    public data: any = {};
    public load: any = false;
    public items: any = [];
    public summary: any = { total_count: 0, total_bonus: '0.00' };
    public page_nat: any = { current_page: 1, page_limit: 50, total_pages: 0 };
    private selected_company: any = null;

    constructor(private http: HttpService, private activatedRoute: ActivatedRoute, private router: Router) {
        this.selected_company = this.http.getStaticSelectedCompany();

        let queryParams = this.activatedRoute.snapshot.queryParams;
        let available = false;

        if (queryParams.page_no) {
            this.data.page_no = queryParams.page_no;
            available = true;
        }
        if (queryParams.date_from) {
            this.data.date_from = queryParams.date_from;
            available = true;
        }
        if (queryParams.date_to) {
            this.data.date_to = queryParams.date_to;
            available = true;
        }
        if (queryParams.player_search) {
            this.data.player_search = queryParams.player_search;
            available = true;
        }

        if (available) {
            this.filter(queryParams.page_no ? queryParams.page_no : 1);
        } else {
            let date = new Date();
            this.data.date_from = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
            this.data.date_to = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
        }
    }

    async filter(page_no = 1) {
        this.load = true;

        if (page_no) {
            this.data.page_no = page_no;
        }

        let y: any = await this.http.post("/admin/topup-point-log", this.data);

        if (y.status && y.items) {
            this.items = y.items;
            this.summary = y.summary;
            this.page_nat = y.page_nat;

            const queryParams = { ...this.data };
            delete queryParams.user_uuid;
            delete queryParams.company_uuid;

            this.router.navigate(['/lo', this.selected_company, 'topup-point-log'], { queryParams: queryParams });
        } else {
            this.items = [];
            this.summary = { total_count: 0, total_bonus: '0.00' };
            this.page_nat = { current_page: 1, page_limit: 50, total_pages: 0 };
        }

        this.load = false;
    }

    formatDate(dateString: string) {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleString();
    }
}
